<template>

    <div class="preferences">
        <v-main>
            <v-container>
                <top-search-bar :mobile_number="mobile_number" :logo="logo" />
                <v-row justify="center">
                    <v-col cols="12" sm="10" md="8" lg="12">
                        <v-card color="basil">
                            <v-card-title class="text-center justify-center py-6">
                                <h4 class="font-weight-bold text-h2 basil--text">
                                    Setting's
                                </h4>
                            </v-card-title>

                            <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                                <v-tab v-for="tabitem in tabItems" :key="tabitem">
                                    {{ tabitem }}
                                </v-tab>
                            </v-tabs>

                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-tabs-items v-model="tab">

                                    <v-card color="basil" flat>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <v-tab-item>
                                                <!-- <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="pb-0">
                                                        Customer Type
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="pb-0">
                                                        Who are your customers?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="pb-0">
                                                        <v-select v-on:change="customer_type_change"
                                                            v-model="customer_type" :items="customer_types"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row> -->
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Stock Keeping
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Enable Stock Keeping
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="opening_stock" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        HSN/ SAC Code
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to maintain HSN/ SAC Code?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="product_code" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        SKU/ Item Code
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to maintain SKU/ Item Code?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="SKU" :items="options_yes_no" label="Select"
                                                            outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Manufacturing Date
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to keep Manufacturing Date?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="manufacturing_date" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Expiry Date
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to keep Expiry Date?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="expiry_date" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Barcode
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to enable barcode
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="barcode" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="show_display_mrp">
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Purchase Price <span v-show="show_to_retailers">to
                                                            retailers</span>
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you want to enable Purchase Price?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="display_mrp" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
                                                        Display Sale Price
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7" class="py-0">
                                                        Do you wan to show your Sale Price to Retailers?
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
                                                        <v-select v-model="display_rate" :items="options_yes_no"
                                                            label="Select" outlined dense></v-select>
                                                    </v-col>
                                                </v-row>

                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3">
                                                        Your Shop Info/ Message
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7">
                                                        If you add a general info or message. It wil appear at the top
                                                        of the page
                                                        <v-tooltip v-model="show" right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2">

                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3" md="3" lg="3">
                                                    </v-col>
                                                    <v-col cols="12" sm="7" md="7" lg="7">
                                                        <v-textarea outlined name="input-7-4" v-model="general_info">
                                                        </v-textarea>
                                                    </v-col>
                                                    <v-col cols="12" sm="2" md="2" lg="2">

                                                    </v-col>
                                                </v-row>

                                            </v-tab-item>
                                            <v-tab-item>
                                                <v-card color="basil" flat>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Category
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="pt-0">
                                                            You can create different categories to group your products
                                                            <v-tooltip v-model="show" right>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                                        <v-icon color="grey lighten-1">
                                                                            mdi-information
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Programmatic tooltip</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                        <v-col cols="12" sm="2" md="2" lg="2" class="pt-0">

                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Categories options
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="mb-3">
                                                            <!-- SHOW PRODUCT LISTS -->
                                                            <v-sheet elevation="10" class="py-4 px-1">
                                                                <v-chip-group column multiple>
                                                                    <div v-for="(category,index) in categories"
                                                                        :key="index">
                                                                        <v-chip v-if="chip" class="ma-2" close
                                                                            @click:close="chip = false">
                                                                            {{ category }}
                                                                        </v-chip>
                                                                    </div>

                                                                </v-chip-group>
                                                            </v-sheet>

                                                            <!-- SHOW PRODUCT LISTS -->
                                                        </v-col>
                                                        <v-col cols="12" sm="2" md="2" lg="2" class="pt-0">
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="pt-0">
                                                            <v-sheet elevation="10" class="py-2 px-3">
                                                                <v-text-field v-model="newCategory" outlined
                                                                    label="Add Category" placeholder="Add Category"
                                                                    required @change="addNewCategory">
                                                                </v-text-field>
                                                            </v-sheet>
                                                        </v-col>
                                                        <v-col cols="12" sm="2" md="2" lg="2" class="pt-0">
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-tab-item>

                                            <v-tab-item>
                                                <v-card color="basil" flat>

                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Unit Options
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="mb-3">
                                                            <v-sheet elevation="10" class="py-4 px-1">
                                                                <v-chip-group v-model="unitList" column multiple>
                                                                    <v-chip filter variant="outlined"
                                                                        v-for="(unit,index) in units" :value="unit"
                                                                        :key="index">
                                                                        {{ unit }}
                                                                    </v-chip>
                                                                </v-chip-group>
                                                            </v-sheet>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Add More Units
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="mb-3">
                                                            <v-sheet elevation="10" class="py-2 px-3">
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-text-field v-model="newUnit" outlined
                                                                            label="Add Unit"
                                                                            placeholder="Unit (Short Name) eg., Kilogram (kg)"
                                                                            required @change="addNewUnit">
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" v-if="showUnitError">
                                                                        <span style="color:red">
                                                                            Invalid Unit Format.
                                                                            Please input valid format.
                                                                            Unit (Short Name) eg., Kilogram(kg)
                                                                        </span>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-sheet>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-tab-item>

                                            <v-tab-item>
                                                <v-card color="basil" flat>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Tax Option
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="mb-3">
                                                            <v-sheet elevation="10" class="py-4 px-1">
                                                                <v-chip-group v-model="taxList" column multiple>
                                                                    <v-chip filter variant="outlined"
                                                                        v-for="(tax,index) in allTaxes" :value="tax"
                                                                        :key="index">
                                                                        {{ tax }}
                                                                    </v-chip>
                                                                </v-chip-group>
                                                            </v-sheet>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="3" md="3" lg="3" class="pt-0">
                                                            Add More Tax
                                                        </v-col>
                                                        <v-col cols="12" sm="7" md="7" lg="7" class="mb-3">
                                                            <v-sheet elevation="10" class="py-2 px-3">
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-text-field v-model="newTax" outlined
                                                                            label="Add Tax" placeholder="Eg. GST @ 0%"
                                                                            required @change="addNewTax">
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" v-if="showTaxError">
                                                                        <span style="color:red">
                                                                            Invalid Tax Format.
                                                                            Please input valid format.
                                                                            eg., GST @ 10%
                                                                        </span>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-sheet>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-tab-item>

                                            <v-tab-item>
                                                <v-card color="basil" flat>
                                                    <ImageGallery />
                                                </v-card>
                                            </v-tab-item>

                                            <v-tab-item>
                                                <v-card color="basil" flat>
                                                    <h4>INVOICE SETTINGS</h4>
                                                </v-card>
                                            </v-tab-item>

                                        </v-card-text>
                                        <v-divider class="mt-12"></v-divider>
                                        <v-card-actions>
                                            <v-btn text>Cancel</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn :disabled="!valid" color="primary" text @click="validate">Submit
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-tabs-items>
                            </v-form>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer.vue'
    import TopSearchBar from '@/components/TopSearchBar.vue'
    import ImageGallery from './ImageGallery.vue'

    export default {
        name: 'Preferences',
        components: {
            Footer,
            TopSearchBar,
            ImageGallery
        },
        data() {
            return {
                mobile_number: null,
                logo: null,
                valid: true,
                customer_type: null,
                visibility: null,
                display_margin: null,
                show_display_mrp: true,
                show_to_retailers: false,
                categories: [],
                subCategories: [],
                general_info: null,
                customer_types: ['Only Retailers', 'Individual Customer', 'Both'],
                options_yes_no: ['yes', 'no'],
                items: [],
                search: "", //sync search
                optional_categories: [],
                category_to_show: 25,

                // Other fields -
                product_code: 'yes',
                SKU: 'yes',
                display_rate: 'yes',
                display_mrp: 'yes',
                // Other fields -

                // new fields -
                opening_stock: 'yes',
                barcode: 'yes',
                units: [],
                unit_short_name: [],
                unitList: [],
                newUnit: '',
                newUnitShortName: [],
                newUnitFullName: [],
                chip: true,
                newCategory: null,
                noOfCategories: 0,
                newlyAddedUnitList: [],
                manufacturing_date: 'yes',
                expiry_date: 'yes',
                tab: null,
                tabItems: [
                    'General Settings', 'Categories', 'Units', 'Taxes', 'Image Gallery', 'Invoice Settings'
                ],
                showUnitError: false,
                regexCondition: true,
                allTaxes: [],
                taxList: [],
                newTax: '',
                showTaxError: false,
                // new fields 
            }
        },
        computed: {
            // resultQuery() {
            //     let difference = this.optional_categories.filter(x => !this.categories.includes(x))
            //     console.log("difference",difference)
            //     return difference
            // },

        },
        methods: {
            preferenceUpdate() {

                let regex = /[\w\s]*\([A-Za-z]+\)/;
                if (this.newUnit != '') {
                    this.regexCondition = regex.test(this.newUnit)
                } else {
                    this.regexCondition = true
                }

                if (this.regexCondition == true) {
                    let itemExists = 0;
                    if (this.newUnit != '') {

                        const indexOfOpeningBracket = this.newUnit.indexOf('(');
                        const unitShortCode = this.newUnit.substring(indexOfOpeningBracket + 1, this.newUnit.length - 1)

                        const unitFullName = this.newUnit.substring(0, indexOfOpeningBracket - 1)



                        itemExists = this.units.filter(item =>
                            item.includes(unitFullName + " (" + unitShortCode + ")")
                        );
                    }


                    if (itemExists.length > 0) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: "Unit Already Exsits",
                        });
                    } else {
                        let data = {
                            customer_type: this.customer_type,
                            visibility: this.visibility,
                            SKU: this.SKU,
                            product_code: this.product_code,
                            display_rate: this.display_rate,
                            display_mrp: this.display_mrp,
                            display_margin: this.display_margin,
                            general_info: this.general_info,
                            categories: this.categories,
                            selectedUnits: this.unitList,

                            newUnitFullName: this.newUnitFullName,
                            newUnitShortName: this.newUnitShortName,
                            // newlyAddedUnitList: this.newlyAddedUnitList,

                            opening_stock: this.opening_stock,
                            barcode: this.barcode,
                            manufacturing_date: this.manufacturing_date,
                            expiry_date: this.expiry_date,
                            taxes: this.taxList,
                        }
                        const sorted = [...this.categories];
                        sorted.sort((a, b) => a.localeCompare(b));
                        this.categories = sorted

                        this.$store.dispatch('preferenceUpdate', data)
                            .then((res) => {
                                switch (res.data.status) {
                                    case 2:
                                        this.$swal({
                                            icon: 'success',
                                            title: 'Congrats',
                                            text: 'Preferences updated successfully',
                                        });
                                        break;
                                    case 3:
                                        this.$swal({
                                            icon: 'error',
                                            title: 'Oops...',
                                            text: 'You cannot add category more than 100',
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            })
                            .catch(err => {
                                // console.log(err)
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: err,
                                });
                            })
                    }
                } else if (this.regexCondition == false) {
                    this.showUnitError = true
                }



            },
            validate() {
                this.preferenceUpdate()
            },
            customer_type_change() {
                if (this.customer_type == 'Individual Customer') {
                    this.display_mrp = 'Yes'
                    this.show_display_mrp = false
                    this.show_to_retailers = false
                } else if (this.customer_type == 'Both') {
                    this.display_mrp = null
                    this.show_display_mrp = true,
                        this.show_to_retailers = true
                } else {
                    this.display_mrp = null
                    this.show_display_mrp = true
                    this.show_to_retailers = false
                }
            },
            updateTags() {
                this.$nextTick(() => {
                    this.categories.push(...this.search.split(","));
                    this.$nextTick(() => {
                        this.search = "";
                    });
                });
            },
            addOptionalCategory(category) {
                if (this.categories.includes(category)) {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Category already selected',
                    });
                } else {
                    this.categories.push(category);
                }
                //this.categories.push(category);
            },
            addNewUnit() {

                // let data = {
                //     name: this.newUnit,
                //     short_name: this.newUnitShortName,
                // }

                // const lowercaseArray = this.units.map(item => item.toLowerCase());
                // const itemExists = lowercaseArray.includes(this.newUnit.toLowerCase());

                let regex = /[\w\s]*\([A-Za-z]+\)/;

                // console.log("Regex",regex.test('abc1@ ( xyz)'))

                if (regex.test(this.newUnit) == true) {

                    this.showUnitError = false
                    this.regexCondition = true

                    const itemExists = this.units.filter(item =>
                        item.toLowerCase().includes(this.newUnit.toLowerCase())
                    );

                    if (itemExists.length > 0) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: "Unit Already Exsits",
                        });
                    } else if (itemExists == 0) {

                        // console.log("unitlist", this.unitList)

                        const indexOfOpeningBracket = this.newUnit.indexOf('(');
                        let unitShortCode = this.newUnit.substring(indexOfOpeningBracket + 1, this.newUnit.length - 1)


                        console.log("shortcode", unitShortCode)

                        const unitFullName = this.newUnit.substring(0, indexOfOpeningBracket - 1)

                        console.log("Full Name", unitFullName)

                        // this.units.push(this.newUnit.toUpperCase())
                        // this.newlyAddedUnitList.push(this.newUnit)
                        this.newUnit = '';

                        this.newUnitFullName.push(unitFullName.toUpperCase());
                        unitShortCode = unitShortCode[0].toUpperCase() + unitShortCode.slice(1)
                        this.newUnitShortName.push(unitShortCode);

                        this.units.push(this.newUnitFullName + " (" + this.newUnitShortName + ")");

                        const sorted = [...this.units];
                        sorted.sort((a, b) => a.localeCompare(b));
                        this.units = sorted

                        // this.$store.dispatch('addNewUnit', data)
                        //     .then((res) => {
                        //         if (res.data.status == '2') {
                        //             this.fetchAllUnits()
                        //             this.newUnit = '';
                        //             this.newUnitShortName = '';
                        //         }
                        //     })
                        //     .catch(err => {
                        //         this.$swal({
                        //             icon: 'error',
                        //             title: 'Oops...',
                        //             text: err,
                        //         });
                        //     })
                    }

                } else {
                    this.showUnitError = true
                    this.regexCondition = true
                }




            },
            fetchAllUnits() {
                this.units = []
                this.unit_short_name = []
                this.$store.dispatch('getUnits')
                    .then((res) => {
                        // console.log("units",res.data.data)
                        let len = res.data.data.length
                        for (let i = 0; i < len; i++) {
                            // this.units.push(res.data.data[i].name)
                            // this.unit_short_name.push(res.data.data[i].short_name)
                            this.units.push(res.data.data[i].name + " (" + res.data.data[i].short_name + ")")
                        }

                        // SORTING UNITS FULL NAME
                        const sorted1 = [...this.units];
                        sorted1.sort((a, b) => a.localeCompare(b));
                        this.units = sorted1
                        // SORTING UNITS FULL NAME

                        // // SORTING UNITS SHORT NAME
                        // const sorted2 = [...this.unit_short_name];
                        // sorted2.sort((a, b) => a.localeCompare(b));
                        // this.unit_short_name = sorted2
                        // // SORTING UNITS SHORT NAME
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            addNewCategory() {

                if (this.noOfCategories < 100) {

                    console.log("Categories size", this.categories.length)
                    const lowercaseArray = this.categories.map(item => item.toLowerCase());
                    const itemExists = lowercaseArray.includes(this.newCategory.toLowerCase());


                    if (itemExists == true) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: "Category Already Exsits",
                        });
                    } else if (itemExists == false) {
                        this.categories.push(this.newCategory)
                        const sorted = [...this.categories];
                        sorted.sort((a, b) => a.localeCompare(b));
                        this.categories = sorted
                        this.newCategory = ''
                        this.noOfCategories = this.categories.length
                    }

                } else if (this.noOfCategories >= 100) {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: "You can add only 100 categories",
                    });
                }


            },
            fetchAllTaxes() {
                this.allTaxes = [];
                this.$store.dispatch('getTaxes')
                    .then((res) => {
                        console.log("tax", res)
                        let len = res.data.data.length
                        for (let i = 0; i < len; i++) {
                            this.allTaxes.push(res.data.data[i].name)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            addNewTax() {

                let regex = /[\w\s]*\d%/;

                if (regex.test(this.newTax) == true) {
                    this.showTaxError = false
                    this.allTaxes.push(this.newTax)
                    this.newTax = ''
                } else {
                    this.showTaxError = true
                }

                // console.log("regex", regex.test('GST @ 5%'))

                // alert(regex.test(this.newTax));

            },
        },
        created() {
            this.$store.dispatch('getCategories')
                .then((response) => {
                    console.log(response.data.data)
                    this.optional_categories = response.data.data
                })
                .catch(err => {
                    console.log(err)
                })
            this.$store.dispatch('getPreferences')
                .then((res) => {
                    if (res.data.data) {
                        console.log("Preference", res.data.data)
                        this.preferences = res.data.data
                        this.customer_type = this.preferences.customer_type
                        this.visibility = this.preferences.visibility
                        this.SKU = this.preferences.SKU
                        this.product_code = this.preferences.product_code
                        this.display_rate = this.preferences.display_rate
                        this.display_mrp = this.preferences.display_mrp
                        this.display_margin = this.preferences.display_margin
                        this.general_info = this.preferences.general_info
                        this.opening_stock = this.preferences.opening_stock
                        this.barcode = this.preferences.barcode

                        this.manufacturing_date = this.preferences.manufacturing_date
                        this.expiry_date = this.preferences.expiry_date


                        if (this.preferences.categories[0] != null)
                            this.categories = this.preferences.categories
                        this.noOfCategories = this.categories.length
                        const sorted = [...this.categories];
                        sorted.sort((a, b) => a.localeCompare(b));
                        this.categories = sorted

                        this.unitList = this.preferences.units
                        this.taxList = this.preferences.taxes

                        // // Make a copy of the original array to avoid mutating the data directly
                        // const sorted1 = [...this.units];
                        // // Sort the array in alphabetical order
                        // sorted1.sort((a, b) => a.localeCompare(b));
                        // // Capitalize words that have only lowercase letters
                        // sorted1.forEach((item, index) => {
                        //     if (item === item.toLowerCase()) {
                        //         sorted1[index] = item.charAt(0).toUpperCase() + item.slice(1);
                        //     }
                        // });
                        // this.units = sorted1

                        // console.log("Sorted Units",this.units)


                        // const sorted1 = [...this.units];
                        // sorted1.sort((a, b) => a.localeCompare(b));
                        // this.units = sorted1
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            this.fetchAllUnits()
            this.fetchAllTaxes()
        },
        mounted() {
            // console.log(this.category_to_show - this.resultQuery.length)

        }
    }
</script>

<style scoped>
    .tag-input span.chip {
        background-color: #1976d2;
        color: #fff;
        font-size: 1em;
    }

    .tag-input span.v-chip {
        background-color: #1976d2;
        color: #fff;
        font-size: 1em;
        padding-left: 7px;
    }

    .tag-input span.v-chip::before {
        content: "label";
        font-family: 'Material Icons';
        font-weight: normal;
        font-style: normal;
        font-size: 20px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: 'liga';
        -webkit-font-smoothing: antialiased;
    }
</style>